import React from "react";

// Custom dark tooltip for Recharts
export function ChartTooltip({ active, payload, label, valueFormatter = (v) => v }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="glass rounded-md px-3 py-2 text-xs shadow-lg" data-testid="chart-tooltip">
      {label && <div className="font-semibold text-foreground mb-1">{label}</div>}
      <div className="space-y-1">
        {payload.map((p, i) => (
          <div key={i} className="flex items-center gap-2">
            <span
              className="inline-block h-2 w-2 rounded-full"
              style={{ background: p.color || p.fill }}
            />
            <span className="text-muted-foreground">{p.name}:</span>
            <span className="text-foreground font-semibold num">{valueFormatter(p.value)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
